export const colorPickerStyle = () => ({
  '& .ms-ColorPicker': {
    width: '288px',

    '& .ms-ColorPicker-panel': {
      padding: '12px',
      background: '#FFFFFF',
      border: '1px solid #605E5C',
    },
  },
});
